import React from 'react';
import OrgTag from '../../components/OrgTag';
import { fmtNumber } from '../../hooks';
import { Badge, Button } from '../../ui/basics';
import DirectoryList from './DirectoryList';

const SECTIONS = [
  { title: 'Basics', fields: [
    { key: 'client_name', label: 'Client name', required: true, full: true, max: 64 },
    { key: 'status', label: 'Status', type: 'select', options: ['Active', 'Archive'], default: 'Active', hint: 'Archived clients disappear from the add/edit forms.' },
    { key: 'industry', label: 'Industry', suggest: 'industry' },
    { key: 'category', label: 'Category', suggest: 'category' },
    { key: 'practice', label: 'Practice' },
    { key: 'primary_owner', label: 'Primary owner', type: 'person' },
    { key: 'ownership', label: 'Ownership' },
    { key: 'client_lead', label: 'Client lead', type: 'person' },
  ] },
  { title: 'Contact', fields: [
    { key: 'contact_number', label: 'Phone', type: 'phone' },
    { key: 'email_id', label: 'Email', type: 'email' },
    { key: 'website', label: 'Website', type: 'url', max: 128 },
    { key: 'fax', label: 'Fax', type: 'phone' },
  ] },
  { title: 'Address', fields: [
    { key: 'address', label: 'Address', full: true },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State', suggest: 'state' },
    { key: 'postal_code', label: 'Postal code' },
    { key: 'country', label: 'Country' },
  ] },
  { title: 'Billing & other', fields: [
    { key: 'msp', label: 'MSP', hint: 'Managed service provider, if the client works through one.' },
    { key: 'vms', label: 'VMS', hint: 'Vendor management system the client uses, if any.' },
    { key: 'payment_terms', label: 'Payment terms' },
    { key: 'federal_id', label: 'Federal ID' },
    { key: 'tag', label: 'Tag' },
  ] },
];

const FILTERS = [
  { key: 'status', placeholder: 'Any status' },
  { key: 'industry', placeholder: 'All industries' },
  { key: 'state', placeholder: 'All states' },
];

const columns = (combined) => [
  { key: 'client_name', label: 'Client', sortable: true, render: (r) => <div><b>{r.client_name}</b>{r.email_id && <div className="muted">{r.email_id}</div>}</div> },
  ...(combined ? [{ key: 'organization', label: 'Organization', render: (r) => <OrgTag orgKey={r.organization} /> }] : []),
  { key: 'industry', label: 'Industry', sortable: true },
  { key: 'city', label: 'Location', sortable: true, render: (r) => [r.city, r.state].filter(Boolean).join(', ') || '—' },
  { key: 'primary_owner', label: 'Owner', sortable: true },
  { key: 'msp', label: 'MSP', sortable: true },
  { key: 'vms', label: 'VMS', sortable: true },
  { key: 'status', label: 'Status', sortable: true, render: (r) => <Badge tone={r.status === 'Active' ? 'success' : ''}>{r.status || '—'}</Badge> },
  { key: 'placements', label: 'Placements', align: 'right', render: (r) => fmtNumber(r.placements) },
  { key: 'modified_on', label: 'Updated', sortable: true, render: (r) => String(r.modified_on || '').slice(0, 8) || '—' },
];

const rowActions = (row, patch) => (
  <Button variant="ghost" size="sm" icon="archive" aria-label={row.status === 'Archive' ? 'Restore client' : 'Archive client'}
    title={row.status === 'Archive' ? 'Restore' : 'Archive'}
    onClick={() => patch(row, { status: row.status === 'Archive' ? 'Active' : 'Archive' }, row.status === 'Archive' ? 'Client restored' : 'Client archived')} />
);

export default function Clients({ org }) {
  return (
    <DirectoryList org={org} kind="clients" noun="Client" plural="clients" idKey="client_id" nameKey="client_name" sections={SECTIONS}
      filters={FILTERS} columns={columns} initialOrdering="client_name" rowActions={rowActions} />
  );
}
